export function startLLMThreadComponentLive(state, _apiKey, _threadID, options = {}) {
  state.streamState = "idle";
  options.render?.();
}
